import React, {
    useState
} from 'react';

import { 
    useIonViewWillEnter,
    useIonRouter,
    IonPage,
    IonHeader,
    IonContent,
    IonToolbar,
    IonTitle,
    IonGrid,
    IonRow,
    IonCol,
    IonButtons,
    IonButton,
    IonBackButton,
    NavContext,
    IonLabel,
    IonItem,
    IonInput,
    IonCard,
    IonCardHeader,
    IonCardSubtitle,
    IonCardTitle,
    IonCardContent,
    IonText,
    IonImg,
    IonIcon,
    IonFooter,
    IonList,
    IonNote
} from '@ionic/react';

import { cloudDownloadOutline, logoGooglePlaystore, logoAppleAppstore, cube } from "ionicons/icons";
import { RouteComponentProps } from "react-router-dom";
import { isPlatform, getPlatforms  } from '@ionic/react';

import { Storage } from '@capacitor/storage';   
import NServer from "../components/NServer";
import { LANGUAGE, GetStr } from "../language/Language";
import { hideTab } from "../components/Tabs";
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';

import './Main.css';  

interface WithdrawProp extends RouteComponentProps<{
    address : string,
    amount : string
    }> 
{} 

const UpdateApp : React.FC<WithdrawProp> = ({match}) => {

    const [version, setVersion] = useState("");
    const [updateInfo, setUpdateInfo] = useState("");
    const [downloadDirect, setDownloadDirect] = useState("");
    const [downloadStore, setDownloadStore] = useState("");

    //	Initializing our router
	const router = useIonRouter();

    useIonViewWillEnter(() => {
        hideTab();
        getData();
    });

    const getData = async () => {
        
        let v = new Vault();
        await v.read();

        const uid = v.account.id;
        
        let platform = "unknown";
        if (isPlatform("desktop"))
            platform = "desktop";
        if (isPlatform("android"))
            platform = "android";
        if (isPlatform("ios"))
            platform = "ios";

        let platform_ids = getPlatforms();

        const state = {
            id: uid,
            platform: platform,
            platform_ids: platform_ids
        }

		var server = new NServer();
        await server.getList("nc_update_info", state);

        if (server.success && server.message != "")
            showAlert(server.message);
        else
        {
            setVersion(server.data.version);
            setUpdateInfo(server.data.update_info);
            setDownloadDirect(server.data.dd_link);
            setDownloadStore(server.data.app_link);
        }
	};

    // download from app store
    const downloadApp = () => {
        window.open(downloadStore,"_system", "location=yes");
    }

    // download directly
    const downloadDir = () => {
        window.open(downloadDirect,"_system", "location=yes");
    }

    return (
        <IonPage>
            <IonContent>
                <div id="border-bk" />
                <IonToolbar color="none">
                    
                </IonToolbar>
                <IonGrid className="ion-no-padding">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="8" size-lg="6" size-xl="4" size="12">
                            <IonImg className="icon-pic" src="/assets/img/big_logo.png" />
                            <div className="ion-text-center"><h1>{ GetStr(LANGUAGE.TXT_UPDATE_CAP) }</h1></div>
                            <div className="ion-text-center">{ version }</div>
                            <IonCard>
                                <IonCardContent>
                                    <div>{ GetStr(LANGUAGE.TXT_UPDATE_INFO) }</div>
                                    <IonList className="update-box">
                                        <IonItem>
                                            <IonText className="text-wrap">{ updateInfo }</IonText>
                                        </IonItem>
                                    </IonList>
                                </IonCardContent>
                            </IonCard>
                            </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
            <IonFooter>
                <IonGrid className="ion-no-padding">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="8" size-lg="6" size-xl="4" size="12">
                            {
                                isPlatform("android") ?
                            <IonButton className="main-but ion-margin" color="primary" expand="block" onClick={downloadApp}>
                                <IonIcon icon={logoGooglePlaystore} />&nbsp;
                                { GetStr(LANGUAGE.TXT_APK_DOWNLOAD) }
                            </IonButton>
                                :
                            <div/>
                            }
                            {
                                isPlatform("ios") ?
                            <IonButton className="main-but ion-margin" color="primary" expand="block" onClick={downloadApp}>
                                <IonIcon icon={logoAppleAppstore} />&nbsp;
                                { GetStr(LANGUAGE.TXT_APP_DOWNLOAD) }
                            </IonButton>
                                :
                            <div/>
                            }
                            {
                                (isPlatform("android") && downloadDirect != "") ?
                            <IonButton className="main-but ion-margin" color="primary" expand="block" onClick={downloadDir}>
                                <IonIcon icon={cloudDownloadOutline} />&nbsp;
                                { GetStr(LANGUAGE.TXT_DIRECT_DOWNLOAD) }
                            </IonButton>
                                :
                            <div/>
                            }
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonFooter>
        </IonPage>
    );
};

export default UpdateApp;